import { useEffect, useRef } from "react";

import SearchField from "~/components/shared/SearchField";
import Button from "~/components/shared/Button";
import { Skeleton } from "~/components/shared/Skeleton";

import { useGuides } from "~/components/shared/StepsEditorSidebar/Guide/useGuide";
import { GuideItem } from "~/components/shared/StepsEditorSidebar/Guide/GuideItem";
import { GuideList } from "~/components/shared/StepsEditorSidebar/Guide/GuideList";
import { times } from "lodash";

export function Guide() {
  const ref = useRef<HTMLDivElement>(null);
  const { onReload, loading, error, selectedItem, selectedAttribute, filter, onFilterChange } =
    useGuides();

  useEffect(() => {
    if (!selectedAttribute) {
      if ((ref.current?.getBoundingClientRect().top ?? 0) < 0) {
        ref.current?.scrollIntoView();
      }
    }
  }, [selectedItem, selectedAttribute]);

  if (error) {
    return (
      <>
        <p className="mt-0">Unable to load content.</p>
        <Button theme="small" onClick={onReload}>
          Retry
        </Button>
      </>
    );
  }

  return (
    <div className="relative flex scroll-mt-3 flex-col gap-3" ref={ref}>
      {selectedItem ? (
        <GuideItem />
      ) : (
        <>
          <SearchField
            autofocus={!!filter}
            searching={loading}
            className="-mb-1 [&_input]:h-8"
            defaultValue={filter}
            onChange={onFilterChange}
          />

          {loading ? (
            <div className="grid gap-2">
              <Skeleton className="h-[22px] w-[50px]" />
              <Skeleton className="h-[22px] w-[200px]" />

              {times(8, (index) => (
                <Skeleton key={index} className="h-[76px] w-full" />
              ))}
            </div>
          ) : (
            <GuideList />
          )}
        </>
      )}
    </div>
  );
}
